var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import Util from '../utils/util';
import Sniffer from '../utils/sniffer';
import Errors from '../error';
import * as Events from '../events';
import XG_DEBUG from '../utils/debug';

function showErrorMsg(pluginName, msg) {
  console.error('[' + pluginName + '] event or callback cant be undefined or null when call ' + msg);
}

var BasePlugin = function () {
  _createClass(BasePlugin, null, [{
    key: 'defineGetterOrSetter',
    value: function defineGetterOrSetter(Obj, map) {
      for (var key in map) {
        Object.defineProperty(Obj, key, map[key]);
      }
    }
  }]);

  function BasePlugin(args) {
    _classCallCheck(this, BasePlugin);

    if (Util.checkIsFunction(this.beforeCreate)) {
      this.beforeCreate(args);
    }
    this.__args = args;
    this.__events = {}; // 对player的事件监听缓存
    this.config = args.config || {};
    this.__init(args);
  }

  _createClass(BasePlugin, [{
    key: 'onPluginsReady',
    value: function onPluginsReady() {}
  }, {
    key: '__init',
    value: function __init(args) {
      var _this = this;

      BasePlugin.defineGetterOrSetter(this, {
        'player': {
          get: function get() {
            return args.player;
          },
          configurable: true
        },
        'playerConfig': {
          get: function get() {
            return args.player && args.player.config;
          },
          configurable: true
        },
        'pluginName': {
          get: function get() {
            if (args.pluginName) {
              return args.pluginName.toLowerCase();
            } else {
              return _this.constructor.pluginName.toLowerCase();
            }
          },
          configurable: true
        },
        'logger': {
          get: function get() {
            return args.player.logger;
          },
          configurable: true
        }
      });
    }
  }, {
    key: 'updateLang',
    value: function updateLang(lang) {
      if (!lang) {
        lang = this.lang;
      }
    }
  }, {
    key: 'on',
    value: function on(event, callback) {
      var _this2 = this;

      if (!event || !callback) {
        showErrorMsg(this.pluginName, 'plugin.on(event, callback)');
        return;
      }
      if (typeof event === 'string') {
        this.__events[event] = callback;
        this.player.on(event, callback);
      } else if (Array.isArray(event)) {
        event.forEach(function (item) {
          _this2.__events[item] = callback;
          _this2.player.on(item, callback);
        });
      }
    }
  }, {
    key: 'once',
    value: function once(event, callback) {
      if (!event || !callback) {
        showErrorMsg(this.pluginName, 'plugin.once(event, callback)');
        return;
      }
      this.player.once(event, callback);
    }
  }, {
    key: 'off',
    value: function off(event, callback) {
      var _this3 = this;

      if (!event || !callback) {
        showErrorMsg(this.pluginName, 'plugin.off(event, callback)');
        return;
      }
      if (typeof event === 'string') {
        delete this.__events[event];
        this.player.off(event, callback);
      } else if (Array.isArray(event)) {
        event.forEach(function (item) {
          delete _this3.__events[event];
          _this3.player.off(item, callback);
        });
      }
    }
  }, {
    key: 'offAll',
    value: function offAll() {
      var _this4 = this;

      Object.keys(this.__events).map(function (item) {
        _this4.__events[item] && _this4.off(item, _this4.__events[item]);
        item && delete _this4.__events[item];
      });
      this.__events = {};
    }
  }, {
    key: 'emit',
    value: function emit(event, res) {
      this.player.emit(event, res);
    }
  }, {
    key: 'registerPlugin',
    value: function registerPlugin(plugin) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      name && (options.pluginName = name);
      return this.player.registerPlugin({ plugin: plugin, options: options });
    }
  }, {
    key: 'getPlugin',
    value: function getPlugin(name) {
      return this.player.getPlugin(name);
    }
  }, {
    key: '__destroy',
    value: function __destroy() {
      var _this5 = this;

      var player = this.player;
      var pluginName = this.pluginName;
      this.offAll();
      Util.clearAllTimers(this);
      if (Util.checkIsFunction(this.destroy)) {
        this.destroy();
      }

      ['player', 'playerConfig', 'pluginName', 'logger'].map(function (item) {
        Object.defineProperty(_this5, item, {
          writable: true
        });
      });
      Object.keys(this).map(function (key) {
        _this5[key] = null;
        delete _this5[key];
      });
      Object.setPrototypeOf && Object.setPrototypeOf(this, null);
      player.unRegisterPlugin(pluginName);
    }
  }, {
    key: 'lang',
    get: function get() {
      return this.player.lang;
    }
  }, {
    key: 'i18n',
    get: function get() {
      return this.player.i18n;
    }
  }, {
    key: 'i18nKeys',
    get: function get() {
      return this.player.i18nKeys;
    }
  }]);

  return BasePlugin;
}();

// BasePlugin.Util = Util
// BasePlugin.Sniffer = Sniffer
// BasePlugin.Errors = Errors
// BasePlugin.Events = Events
// BasePlugin.XG_DEBUG = XG_DEBUG


export { BasePlugin as default, Util, Sniffer, Errors, Events, XG_DEBUG };